export const IconFlagPl = ({ width = 20, height = 20 }) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_16047_4669)'>
      <path
        d='M10 0.625C15.1875 0.625 19.375 4.8125 19.375 10H0.625C0.625 4.8125 4.8125 0.625 10 0.625Z'
        fill='#F9F9F9'
      />
      <path
        d='M10 19.375C4.8125 19.375 0.625 15.1875 0.625 10H19.375C19.375 15.1875 15.1875 19.375 10 19.375Z'
        fill='#ED4C5C'
      />
    </g>
  </svg>
);
